import * as log from "loglevel";
import config from "./envconfig";
export function setup() {	
    if(!config.isProduction) {
        log.enableAll();
    } else {
        log.setLevel(log.levels.ERROR, true);
    }
}